import { projectSelector } from "@rflocal/shared";
import api from "@/utils/api";
import { AnalyticsAbstractAdapter } from "./abstract";
import {
    AnalyticsMethod,
    AnalyticsFlowEvent,
    AnalyticsEvent,
    AnalyticsEventPayload,
    AnalyticsEventData
} from "../types";
/**
 * Roboflow server-side adapter.
 */
export class RfAnalyticsAdapter extends AnalyticsAbstractAdapter {
    protected readonly enabledMethods: AnalyticsMethod[] = [
        AnalyticsMethod.TRACK,
        AnalyticsMethod.PAGE
    ];

    protected postEvent({
        method,
        id,
        data
    }: {
        method: AnalyticsMethod;
        data: AnalyticsEventData;
        id?: string;
    }) {
        let type: AnalyticsEvent;

        if (method === AnalyticsMethod.PAGE) {
            data.page = id;
            type = AnalyticsFlowEvent.PAGE_VIEW;
        } else {
            type = id as AnalyticsEvent;
        }

        const _isAnonymous = !data.workspaceId;
        if (_isAnonymous) {
            data.workspaceId = data._anonymousId;
        }

        const event: AnalyticsEventPayload = { type, data };

        // short-circuit for localhost / dev
        if (projectSelector.isLocal()) {
            console.log(`🧷 [Analytics] ${this.adapterName}`, method, event.type, event);
            return;
        }

        return api.analytics.postEvent(event, { isAnonymous: _isAnonymous });
    }
}
